import { getQueryString } from '@/common/url';

export const getParentPostMessageTargetOrigin = (): string | null => {
  try {
    if (window.self === window.top) {
      return window.location.origin;
    }
  } catch {
    return null;
  }

  const ancestorOrigins = window.location.ancestorOrigins;
  if (ancestorOrigins?.length) {
    const immediateParent = ancestorOrigins.item(0);
    if (immediateParent) return immediateParent;
  }

  if (document.referrer) {
    try {
      return new URL(document.referrer).origin;
    } catch {
      return null;
    }
  }

  const parentOriginParam = getQueryString('parentOrigin');
  if (parentOriginParam) {
    try {
      return new URL(parentOriginParam).origin;
    } catch {
      return null;
    }
  }

  return null;
};
